import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { isEmptyObject, getJCJPIDs } from "../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { csvMappingRechargeSales } from "../../../utils/common/csvMappings/rechargeSales";
import {
  fetchShowAlertRecharge,
  hideAlertRecharge,
  triggerDashboardAudit,
} from "../../../redux/actions";
import OthersLast7DaysView from "../../../views/rechargeSales/others/othersLast7DaysView";
import { useRef } from "react";

const OthersLast7Days = (props) => {
  const dispatch = useDispatch();

  const [value, setValue] = React.useState(1);

  const { getLastSevenTransaction } = useSelector(
    (state) => state.rechargeSalesReducer
  );
  const { headerUnit } = useSelector((state) => state.homeReducer);

  let {
    url,
    csvEndPointUrl,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerFetchLastSevenDayTransaction,
    triggerFetchLastSevenDayCSV,
  } = props;

  // const [downloadCsv, setDownloadCsv] = useState(false);
  let { level, jioPointId, partnerRT, id, retailerId } =
    getJCJPIDs(filterValue);

  const headers = {
    id: id,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    partnerRoleType: partnerRT,
    dispValue: headerUnit.unit,
    selectedDay:
      filterValue?.partnerName === "JC" || filterValue?.partnerName === "JPM"
        ? ""
        : value - 1,
    jprTypeName: "",
    section: props.section,
    moduleName: props.moduleName,
    isRedisActive: "YES",
    jioPointId,
    retailerId,
    level,
  };

  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const pv = PreviousValue(headerUnit);

  useEffect(() => {
    function fetchLast7DaysData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerFetchLastSevenDayTransaction(obj));
    }
    if (
      getLastSevenTransaction &&
      isEmptyObject(getLastSevenTransaction.data) &&
      partnerRT !== "DT"
    ) {
      fetchLast7DaysData();
    }

    if (pv && pv.headerUnit !== headerUnit) {
      fetchLast7DaysData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerFetchLastSevenDayTransaction,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    headerUnit,
  ]);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.moduleName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: props.section,
      },
    };
    triggerDashboardAudit(obj);
  };

  function fetchLast7DaysCsvData() {
    sendAudit();
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: {
        ...headers,
        dist:
          filterValue?.partnerName === "JC" ||
          filterValue?.partnerName === "JPM"
            ? value - 1
            : "",
      },
      extraData: csvEndPointUrl,
      tab: "LAST",
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Others_Last7days",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerFetchLastSevenDayCSV(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = csvMappingRechargeSales({
            partnerRole:
              filterValue.selectedJC === ""
                ? filterValue.selectedPartnerRoleName
                : filterValue.selectedJC === "ALL"
                ? filterValue.selectedPartnerRoleName
                : "JP",
            data: response.content,
            section: "last7Days",
          });
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertRecharge());
          setTimeout(() => {
            dispatch(hideAlertRecharge());
          }, 5000);
        }
        // setDownloadCsv(false)
      })
    );
  }
  const days = [
    {
      label: "Day 1",
      value: 1,
    },
    {
      label: "Day 2",
      value: 2,
    },
    {
      label: "Day 3",
      value: 3,
    },
    {
      label: "Day 4",
      value: 4,
    },
    {
      label: "Day 5",
      value: 5,
    },
    {
      label: "Day 6",
      value: 6,
    },
    {
      label: "Day 7",
      value: 7,
    },
  ];
  const handleChange = (unit) => (event) => {
    setValue(event.target.value);
  };

  return (
    <OthersLast7DaysView
      partnerRT={partnerRT}
      fetchLast7DaysCsvData={fetchLast7DaysCsvData}
      handleChange={handleChange}
      isCsvActive={props.isCsvActive}
      days={days}
    />
  );
};

OthersLast7Days.propTypes = {
  url: PropTypes.string,
  content: PropTypes.object,
};

export default OthersLast7Days;
